module.exports = __webpack_public_path__ + "img/Picture15.4c1bf4c0.jpg";